export default {"src":"/_next/static/media/trustpilot-icon.807e9704.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};